module.exports = __webpack_public_path__ + "assets/flags@2x.d429a5777afaf2fc349652e812e9bb11.png";